import { CustomFieldValidationRules } from '@/gql/graphql'

export class CustomFieldSettingsValidation {
  rules: CustomFieldValidationRules[]

  constructor(rules?: CustomFieldValidationRules[]) {
    this.rules = Array.from(rules || [])
  }

  get required(): boolean {
    return this.rules.includes(CustomFieldValidationRules.Required)
  }

  set required(required: boolean) {
    if (required) {
      this.rules.push(CustomFieldValidationRules.Required)
    } else {
      delete this.rules[this.rules.indexOf(CustomFieldValidationRules.Required)]
    }
  }

  public toGraphQLInput(): CustomFieldValidationRules[] {
    return [
      this.required ? CustomFieldValidationRules.Required : CustomFieldValidationRules.Nullable,
    ]
  }
}
